import Consts from "Interfaces/Consts";

type Props = {
    dir: string;
    componentId: string;
    isMiniNews: boolean;
    isTablet: boolean;
    pauseNews: () => void;
    isAutoplayActive: boolean;
}

const CarouselControlButtons: React.FC<Props> = ({ dir, componentId, isMiniNews, isTablet, pauseNews, isAutoplayActive, }) => {

    const displayPauseBtn = isMiniNews && isTablet;
    const isRtl = dir === "rtl";

    return <>

        {
            displayPauseBtn &&

            <span className="mst-pause-btn">

                <button
                    id={"pause-carouselContentControls-" + componentId}
                    className="btn btn-pause carousel-control-pause"
                    role="button" onClick={pauseNews}
                    aria-label={`${isAutoplayActive ? Consts.stop : Consts.play}`}>

                    <span className={`fas ${isAutoplayActive ? 'fa-pause ' : 'fa-play '} `} aria-hidden="true"></span>
                    <span className="sr-only">{isAutoplayActive ? Consts.stop : Consts.play}</span>

                </button>

            </span>
        }

        {
            isMiniNews &&
            <span className={`btn-prev btn-prev-${componentId} 
                ${isRtl ? "swiper-button-next" : "swiper-button-prev"}`}>
            </span>
        }

        <span className="navigation-contianer"></span>

        {
            isMiniNews &&
            <span className={`btn-next btn-next-${componentId}
                ${isRtl ? "swiper-button-prev" : "swiper-button-next"}`}>
            </span>
        }

    </>
}

export default CarouselControlButtons;